import { useStrictLocalization } from "@faire/web--source/common/localization";

import { QuickAction, QuickActionType, QuickActions } from "../types";

export const useBrandQuickActions = (): QuickActions => {
  const { strictLocalize } = useStrictLocalization();

  const requestCommissionChange: QuickAction = {
    id: QuickActionType.REQUEST_COMMISSION_CHANGE,
    label: strictLocalize({
      defaultMessage: "Request commission change",
      description: {
        text: "Quick action button to request commission change",
      },
    }),
  };

  const editItemAvailability: QuickAction = {
    id: QuickActionType.EDIT_ITEM_AVAILABILITY,
    label: strictLocalize({
      defaultMessage: "Edit item availability",
      description: {
        text: "Quick action button to edit item availability",
      },
    }),
  };

  const cancelAnOrder: QuickAction = {
    id: QuickActionType.CANCEL_AN_ORDER,
    label: strictLocalize({
      defaultMessage: "Cancel an order",
      description: {
        text: "Quick action button to cancel an order",
      },
    }),
  };

  const acceptAnOrder: QuickAction = {
    id: QuickActionType.ACCEPT_AN_ORDER,
    label: strictLocalize({
      defaultMessage: "Accept an order",
      description: {
        text: "Quick action button to accept an order",
      },
    }),
  };

  return {
    [QuickActionType.REQUEST_COMMISSION_CHANGE]: requestCommissionChange,
    [QuickActionType.EDIT_ITEM_AVAILABILITY]: editItemAvailability,
    [QuickActionType.CANCEL_AN_ORDER]: cancelAnOrder,
    [QuickActionType.ACCEPT_AN_ORDER]: acceptAnOrder,
  };
};
